module.exports = __webpack_public_path__ + "static/media/img-epaper-bg-UNSUB-L.e17f3722.webp";